<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px"
         viewBox="3 3 93 91" style="enable-background:new 3 3 93 91;" xml:space="preserve"
         :width="width"
         :height="height">
		<g>
			<rect x="17" y="36" class="st0" width="64" height="46.8"/>
            <polygon class="st0" points="48,7 8,28.4 88,28.4 	"/>
            <rect x="8" y="89" class="st1" width="80" height="5"/>
            <!--<rect x="13.8" y="83.2" class="st1" width="68.4" height="3.6"/>-->
		</g>
	</svg>
</template>

<script>
    export default {
        name: "DepartmentIcon",
        props: {
            width: {
                type: [Number, String],
                default: 25
            },
            height: {
                type: [Number, String],
                default: 25
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>
    .st0 {
        fill: none;
        stroke-width: 4px;
        stroke: #000000;
        stroke-miterlimit: 10;
    }

    .st1 {
        fill: #000000;
    }
</style>
